import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IModifierGroupsContext, ModifierGroupsContext } from '../../../modifierGroupsState/modifierGroupsContext';
import classNames from 'classnames';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, searchString, IDSelectedCustomer } =
		useContext<IModifierGroupsContext>(ModifierGroupsContext);

	const resetBtnClasses = classNames(style.resetBtn, {
		[style.active]: searchString || IDSelectedCustomer,
	});

	return (
		<Button
			className={resetBtnClasses}
			theme="secondary"
			onClick={resetSelectedControls}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
